import EventSeatIcon from "@mui/icons-material/EventSeat";
import Refresh from "@mui/icons-material/Refresh";
import {
  Alert,
  Box,
  IconButton,
  LinearProgress,
  Tab,
  Tabs,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Button, PageHeader, Spacer } from "common";
import ScriptFilter from "features/booking-documents/ScriptFilter";
import ScriptList from "features/booking-documents/ScriptList";
import useScriptList from "features/booking-documents/useScriptList";
import I18n from "i18n";
import moment from "moment";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import CateringFilter from "./CateringFilter";
import CateringList from "./CateringList";
import useCateringList from "./useCateringList";

export default function CateringPage() {
  const [tab, setTab] = useState(0);
  const {
    cateringData,
    loading,
    load,
    handleFilter,
    setRange,
    range,
    loaded,
    isEmpty,
    setSettings,
  } = useCateringList();
  const scripts = useScriptList();
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        //position: "relative",
      }}
    >
      <Box
        sx={{
          px: smDown ? 2 : 0,
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <PageHeader avatar={<EventSeatIcon />} title={I18n.t("Catering.title")}>
          <IconButton onClick={() => (tab === 0 ? load() : scripts.load())}>
            <Refresh />
          </IconButton>
        </PageHeader>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 1 }}>
          <Tab label={I18n.t("Catering.title")} />
          <Tab label={I18n.t("BookingDocument.title")} />
        </Tabs>
        {tab === 0 && (
          <>
            <CateringFilter setRange={setRange} range={range} />
            <Spacer h={1} />
            <CateringList cateringData={cateringData} />
            {loading && (
              <LinearProgress
                sx={{ position: "fixed", left: 0, top: 0, right: 0 }}
              />
            )}
            {isEmpty && (
              <Alert
                severity="info"
                action={
                  <Button
                    variant="text"
                    title="Reset"
                    size="small"
                    onClick={() => {
                      setRange({
                        start: moment().startOf("day"),
                        end: moment().endOf("day"),
                      });
                      setSettings({
                        programIds: undefined,
                        boatIds: undefined,
                      });
                    }}
                  />
                }
              >
                A jelenelgi feltételekkel nem található adat.
              </Alert>
            )}
          </>
        )}
        {tab === 1 && (
          <>
            <ScriptFilter setRange={scripts.setRange} range={scripts.range} />
            <Spacer h={1} />
            <ScriptList documents={scripts.documents} />
            {scripts.loading && (
              <LinearProgress
                sx={{ position: "fixed", left: 0, top: 0, right: 0 }}
              />
            )}
            {scripts.isEmpty && (
              <Alert
                severity="info"
                action={
                  <Button
                    variant="text"
                    title="Reset"
                    size="small"
                    onClick={() => {
                      scripts.setRange({
                        start: moment().startOf("day"),
                        end: moment().endOf("day"),
                      });
                      scripts.setSettings({
                        programIds: undefined,
                        boatIds: undefined,
                      });
                    }}
                  />
                }
              >
                A jelenelgi feltételekkel nem található adat.
              </Alert>
            )}
          </>
        )}
      </Box>
      <Outlet />
    </Box>
  );
}
